export const DEFAULT_DATE = 'YYYY-MM-DD HH:mm:ss' as const;
export const DEFAULT_DAY = 'YYYY-MM-DD' as const;
export const HOUR = 'hour' as const;
